var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureWebApps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_21)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.064 160.227C148.248 166.249 139.081 169.11 129.962 169.11C116.936 169.11 104.41 163.338 95.7929 152.096C81.4633 133.277 85.0694 106.378 103.858 91.9741C111.674 85.9518 120.842 83.0914 129.961 83.0914C142.987 83.0914 155.513 88.863 164.13 100.104C178.509 118.923 174.852 145.873 156.063 160.226L156.064 160.227ZM169.141 95.9383C159.471 83.142 144.59 76.6173 130.011 76.6173C119.59 76.6173 108.868 80.0296 100 86.8049C78.3558 103.517 74.1472 134.381 90.8818 156.062C100.551 168.859 115.131 175.383 130.011 175.383C140.432 175.383 151.155 171.97 160.023 165.195C181.667 148.735 185.825 117.619 169.141 95.9383Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.635 135.252C104.779 132.391 102.424 129.781 100.57 127.172C96.4124 135.553 95.1099 144.185 94.5581 151.211C95.0593 151.714 95.0593 152.265 95.3593 152.767C97.463 155.377 100.069 157.986 102.424 159.843C102.424 154.072 102.925 144.637 107.635 135.252ZM122.817 102.062C118.91 104.672 115.001 108.084 110.793 112.5C108.688 114.859 106.635 117.217 105.031 119.577C106.835 122.437 108.938 125.348 111.795 128.209C113.899 125.348 116.505 122.186 119.611 119.326C123.519 115.663 127.177 112.551 130.835 110.193L122.819 102.063L122.817 102.062ZM163.726 99.5358C161.922 97.1765 160.069 95.1197 157.714 93.263C151.2 92.2086 140.428 92.4099 128.705 98.6827C131.311 101.543 134.165 104.454 136.772 106.763C152.404 98.1815 163.726 99.5358 163.726 99.5358ZM100.752 126.812L104.91 119.485C98.147 108.746 98.3976 99.863 99.1482 95.6975C97.5951 97.5037 95.7408 99.3605 94.4383 101.168C93.1852 107.241 93.1865 116.123 100.752 126.812Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.027 135.81L111.961 128.483L107.802 135.258C109.906 137.365 112.512 139.725 115.368 141.783C132.853 155.633 150.338 156.938 160.259 156.938C160.761 156.938 163.916 152.773 165.72 150.163C161.211 151.217 142.422 153.575 120.027 135.81Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.693 126.868C102.496 129.478 104.851 132.338 107.757 134.948C108.809 132.589 110.111 130.481 111.915 128.173C109.059 125.312 106.954 122.401 105.151 119.541C103.347 122.151 101.995 124.509 100.693 126.868ZM130.819 110.227C147.001 125.132 165.789 137.679 170.749 141.091C171.215 139.906 171.567 138.679 171.801 137.427C166.59 133.512 153.014 123.074 136.58 106.563C134.977 107.617 132.873 108.32 130.819 110.227ZM128.97 98.5691C125.062 94.4037 120.904 89.7358 116.695 85.0185C114.891 85.521 112.788 86.3234 110.933 87.3778C113.789 92.3457 118.248 97.4654 122.657 102.183C125.062 100.878 126.916 99.6234 128.97 98.5691Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.962 98.5556C126.858 99.6099 124.453 100.614 122.649 102.169L130.816 110.199L136.778 106.786L128.962 98.5556ZM149.863 120.723C145.954 123.885 145.153 129.606 148.059 133.521C151.216 137.686 156.927 138.238 161.085 135.327C164.993 132.165 165.795 126.444 162.889 122.279C159.783 118.364 154.072 117.611 149.863 120.723ZM130.826 143.888C127.168 146.748 126.367 152.269 129.273 155.932C132.128 159.595 137.64 160.399 141.298 157.488C144.954 154.627 145.757 149.407 142.851 145.443C139.995 141.528 134.735 141.027 130.826 143.888ZM98.8889 116.68C93.1272 121.147 92.1248 129.227 96.5346 134.998C100.994 140.769 109.059 141.773 114.821 137.356C120.583 132.938 121.585 124.81 117.175 119.038C112.716 113.267 104.349 112.214 98.8889 116.68Z",
    fill: "#0078D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_21",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_21",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureWebApps);
export default __webpack_public_path__ + "static/media/azure-web-apps.7f0308830d7b2e7b5d22a2374d04736a.svg";
export { ForwardRef as ReactComponent };